import { CALL_PRIVATE_API } from 'js/constants/api';
import { GET } from 'js/constants/requestMethods';
import {
  CLEAN_RESOURCE_FILES_DETAILS,
  GET_RESOURCE_FILES_DETAILS_FAILURE,
  GET_RESOURCE_FILES_DETAILS_REQUEST,
  GET_RESOURCE_FILES_DETAILS_SUCCESS,
} from 'js/constants/actionTypes';
import { DispatchType } from 'src/@types/redux';

export function loadFileDetails(params: any) {
  const { resourceId, resourceType = 'data_sources', fileName } = params;
  return (dispatch: DispatchType) => {
    if (!resourceId) throw new Error('loadFileDetails: resource-id is required');

    const endpoint = `/${resourceType}/${resourceId}/metrics/files_details?file_name=${fileName}`;

    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          GET_RESOURCE_FILES_DETAILS_REQUEST,
          GET_RESOURCE_FILES_DETAILS_SUCCESS,
          GET_RESOURCE_FILES_DETAILS_FAILURE,
        ],
        endpoint: endpoint,
        schema: null,
        requestMethod: GET,
        requestInfo: {
          resourceId,
          resourceType,
          fileName,
        },
      },
    });
  };
}

export const clearFileDetails = () => ({ type: CLEAN_RESOURCE_FILES_DETAILS });
